import React, { useRef, useState, useEffect } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import axios from "axios";
import moment from "moment";
import { ConfigFechas1x500 } from "./modalConfiFecha1x500";
import { ToastsFecha } from "../toasts";

const TablaConfgFechas1x500 = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const accfv1x500 = JSON.parse(localStorage.getItem("accfv1x500"));

  const headCells = [
    {
      id: "num1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-minus">
          {" "}
          MES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "num2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          FECHA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [anio, setAnio] = useState([]);
  const [anios, setAnios] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [fechas, setFechas] = useState();
  const [mes, setMes] = useState();
  const txtAnio = useRef();
  const [vanios, setVanios] = useState(anioActu);
  const [operacion, setOperacion] = useState(1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    if (txtAnio.current.value) {
      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.mes.toLowerCase().includes(target.value) ||
                moment(x.fechaven).format("DD/MM/YYYY").includes(target.value)
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };

  const SeleccionarRegistros = (anio) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "fechavencimiento1x500";
    let nomid = "anio";
    let id = anio;
    let orden = "mes desc";

    let endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var datos = [];
          var enero = "ENERO";
          var febrero = "FEBRERO";
          var marzo = "MARZO";
          var abril = "ABRIL";
          var mayo = "MAYO";
          var junio = "JUNIO";
          var julio = "JULIO";
          var agosto = "AGOSTO";
          var septiembre = "SEPTIEMBRE";
          var octubre = "OCTUBRE";
          var noviembre = "NOVIEMBRE";
          var diciembre = "DICIEMBRE";
          var mess;
          var anio;
          var mesa;

          for (let i = 0; i < response.data.length; i++) {
            anio = response.data[i].anio;
            mesa = response.data[i].mes;

            if (response.data[i].mes === "1") {
              mess = enero;
            } else if (response.data[i].mes === "2") {
              mess = febrero;
            } else if (response.data[i].mes === "3") {
              mess = marzo;
            } else if (response.data[i].mes === "4") {
              mess = abril;
            } else if (response.data[i].mes === "5") {
              mess = mayo;
            } else if (response.data[i].mes === "6") {
              mess = junio;
            } else if (response.data[i].mes === "7") {
              mess = julio;
            } else if (response.data[i].mes === "8") {
              mess = agosto;
            } else if (response.data[i].mes === "9") {
              mess = septiembre;
            } else if (response.data[i].mes === "10") {
              mess = octubre;
            } else if (response.data[i].mes === "11") {
              mess = noviembre;
            } else if (response.data[i].mes === "12") {
              mess = diciembre;
            }

            datos.push({
              fechaven: response.data[i].fechaven,
              mes: mess,
              anio: anio,
              mesa: mesa,
            });
          }
          setRecords(datos);
          setAnios(anio);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarRegistro = (anio, mes) => {
    let campos = "*";
    let nomtab = "fechavencimiento1x500";
    let nomid = "anio";
    let nomid2 = "mes";
    let orden = "mes";

    let endpoint = `${op.conexion}/api/consulta/idsstring2rows?&campos=${campos}&id=${anio}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${mes}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setFechas(response.data);
            setMostrar2(true);
          } else {
            setMostrar2(true);
          }

          let mesf;
          if (response.data[0].mes === "1") {
            mesf = "ENERO";
          } else if (response.data[0].mes === "2") {
            mesf = "FEBRERO";
          } else if (response.data[0].mes === "3") {
            mesf = "MARZO";
          } else if (response.data[0].mes === "4") {
            mesf = "ABRIL";
          } else if (response.data[0].mes === "5") {
            mesf = "MAYO";
          } else if (response.data[0].mes === "6") {
            mesf = "JUNIO";
          } else if (response.data[0].mes === "7") {
            mesf = "JULIO";
          } else if (response.data[0].mes === "8") {
            mesf = "AGOSTO";
          } else if (response.data[0].mes === "9") {
            mesf = "SEPTIEMBRE";
          } else if (response.data[0].mes === "10") {
            mesf = "OCTUBRE";
          } else if (response.data[0].mes === "11") {
            mesf = "NOVIEMBRE";
          } else if (response.data[0].mes === "12") {
            mesf = "DICIEMBRE";
          }
          setMes(mesf);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const ActuFechas = (op, anio, mes) => (e) => {
    blanquear();
    if (op === 4) {
      if (accfv1x500.substring(0, 1) !== "0") {
        setOperacion(4);
        seleccionarRegistro(anio, mes);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accfv1x500.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accfv1x500.substring(2, 3) !== "0") {
        setOperacion(op);
        seleccionarRegistro(anio, mes);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accfv1x500.substring(3, 4) !== "0") {
        setOperacion(op);
        seleccionarRegistro(anio, mes);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const blanquear = () => {
    setFechas();
    setMes();
  };

  const anioselect = (e) => {
    let a = parseInt(e.target.value);

    setVanios(a);
    SeleccionarRegistros(a);
  };

  useEffect(() => {
    var nanio = [];
    var aini = parseInt(anioActu) - 7;
    var afin = parseInt(anioActu);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);

    SeleccionarRegistros(anioActu);
  }, []);

  return (
    <div className="h-100 w-100">
      <div className="h-2 p-4"></div>
      <div className="row card col-md-7 mx-auto amanecergris">
        <div className="col-md-12 p-2">
          <div className="row col-md-12 d-flex justify-content-between">
            <input
              type="text"
              className=" col-3 form-control form-control-sm rounded-pill"
              onChange={handleSearch}
              placeholder="Buscar"
            />
            <div className="col-3">
              <div className="input-group input-group-sm">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-sm"
                  style={{ backgroundColor: "#55acee" }}
                >
                  Año:
                </label>
                <select
                  name="anios"
                  ref={txtAnio}
                  onChange={anioselect}
                  className="form-control"
                >
                  {anio &&
                    anio.map((a, index) => (
                      <option key={index} value={a.anio}>
                        {a.anio}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-3 d-flex justify-content-end">
              <button
                onClick={ActuFechas(1, "")}
                className={
                  accfv1x500.substring(1, 2) === "0"
                    ? "btn btn-sm btn-secondary rounded-circle"
                    : "btn btn-sm btn-primary rounded-circle"
                }
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="m-0">
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index + item.mesa}
                    style={{ padding: "0", backgroundColor: "#fff" }}
                  >
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {item.mes}
                    </TableCell>
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {moment(item.fechaven).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      <button
                        onClick={ActuFechas(4, item.anio, item.mesa)}
                        className={
                          accfv1x500.substring(0, 1) === "0"
                            ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                            : "btn btn-sm mx-1 btn-info rounded-circle"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <button
                        onClick={ActuFechas(2, item.anio, item.mesa)}
                        className={
                          accfv1x500.substring(2, 3) === "0"
                            ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                            : "btn btn-sm mx-1 btn-warning rounded-circle"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={ActuFechas(3, item.anio, item.mesa)}
                        className={
                          accfv1x500.substring(3, 4) === "0"
                            ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                            : "btn btn-sm mx-1 btn-danger rounded-circle"
                        }
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ConfigFechas1x500
          show={mostrar2}
          operacion={operacion}
          fechas={fechas}
          mesf={mes}
          anios={vanios}
          onHideRenderizar={SeleccionarRegistros}
          onHideCancela={handleCancela2}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
      <Dimmer active={activate} />
      <ToastsFecha
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaConfgFechas1x500;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/tablaConfigFecha1x500.js